import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime'

const PpcSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Panel className="ppc-management-filter">
      <Row>
        <Col md={6}>
          <FormGroup>
            <FormControl onChange={props.onInputChange}
                         onKeyPress={doSearch}
                         placeholder="Enter user id, email, mobile, first name or last name"
                         value={props.searchValue}/>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <DateTime timeFormat={false}
                      dateFormat="DD/MM/YYYY"
                      value={props.dateFromValue}
                      onChange={props.onDateFromChange}
                      closeOnSelect
                      inputProps={{
                        placeholder: 'Opt in date from'
                      }}/>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <DateTime timeFormat={false}
                      dateFormat="DD/MM/YYYY"
                      value={props.dateToValue}
                      onChange={props.onDateToChange}
                      closeOnSelect
                      inputProps={{
                        placeholder: 'Opt in date to'
                      }}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
        </Col>
        <Col md={6} className="actions">
            <Button className="red-ghost-btn"
                    onClick={props.onSearch}>Search</Button>

            <Button className="grey-ghost-btn"
                    onClick={props.onClear}>Clear search/filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default PpcSearch;


// WEBPACK FOOTER //
// ./src/components/admin/ppc/management/ppc-search.jsx